import { useState } from 'react'
import { Button, Text } from '@chakra-ui/react'
import { LuCrown } from 'react-icons/lu'
import { showSuccess } from '@/lib/alert'
import { useTransferOwnership } from '@/hooks/agendas/useTransferOwnership'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import type { AgendaMember } from '@/services/agendas'

type Props = {
  agendaId: string
  member: AgendaMember
}

const TransferOwnershipButton = ({ agendaId, member }: Props) => {
  const [open, setOpen] = useState(false)
  const { mutate: transfer, isPending } = useTransferOwnership(agendaId)

  const handleConfirm = () => {
    transfer(member.user.id, {
      onSuccess: () => {
        showSuccess('Propriedade da agenda transferida com sucesso!')
        setOpen(false)
      },
    })
  }

  return (
    <>
      <Button colorPalette="primary" variant="outline" size="xs" onClick={() => setOpen(true)}>
        <LuCrown />
        Tornar dono
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          title="Transferir propriedade"
          body={
            <Text as="span" fontWeight="semibold">
              Tem certeza que deseja tornar <strong>{member.user.name}</strong> o dono dessa agenda?
            </Text>
          }
          subtitle="Esta ação não pode ser desfeita e você deixará de ser dono dessa agenda."
          onConfirm={handleConfirm}
          confirmLabel="Tornar dono"
          confirmColorPalette="primary"
          isPending={isPending}
        />
      )}
    </>
  )
}

export default TransferOwnershipButton
